module.exports = __webpack_public_path__ + "static/media/check_green.a01bca2c.svg";